import { Component } from '@angular/core';
import { LoginService } from '../../services/login.service';
import { UserDTO } from 'src/app/model/user-dto';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MetamaskService } from 'src/app/services/metamask.service';
import { LoginResponseDTO } from 'src/app/model/login-response-dto';

export type PersonalSignDTO = {
  nonce: string,
  accountId: string,
  signature: string
}
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent {
  public email: string = '';
  public password: string = '';
  public working: boolean = false

  constructor(
    public loginService: LoginService,
    public metamaskService: MetamaskService,
    public router: Router,
    public toastr: ToastrService
  ) { }

  loginMetamask() {
    this.working = true
    this.metamaskService.getAccountId()
      .then(accountId => {
        return this.loginService.getNonce(accountId[0]);
      })
      .then((nonceResponse) => {
        return this.metamaskService.signMessage(nonceResponse.accountId, nonceResponse.nonce);
      })
      .then((nonceResponse) => {
        return this.loginService.loginMetamask(nonceResponse.nonce, nonceResponse.accountId, nonceResponse.signature);
      })
      .then(response => {
        this.loginSuccess(response);
      })
      .catch(err => {
        this.toastr.error('Error logging in.');
      })
      .finally(() => {
        this.working = false;
      });
  }

  login() {
    this.working = true

    const user: UserDTO = { userName: this.email, password: this.password };
    this.loginService.login(user)
      .then(response => {
        this.loginSuccess(response);
      }).catch(error => {
        this.toastr.error(`Error logging in.`)
      }).finally(() => {
        this.working = false
      })
  }

  loginSuccess(response: LoginResponseDTO) {
    this.loginService.saveAuthentication(response);
    this.toastr.info(`Welcome, ${response.user.name}!`)
    this.goToIndex()
  }

  goToNodeList(): void {
    this.router.navigate(['node-list']);
  }

  goToIndex(): void {
    this.router.navigate(['']);
  }
}
